export enum AttachmentType {
  AFFIDAVIT = 'Affidavit',
  AFFIRMATION = 'Affirmation',
  ALIAS_SUMMONS = 'Alias Summons',
  AMENDED = 'Amended',
  ANSWER = 'Answer',
  APPEARANCE = 'Appearance',
  APPLICATION = 'Application',
  APPOINTMENT_DOCUMENT = 'Appointment Document',
  ARBITRATION = 'Arbitration',
  BILL_OF_COST = 'Bill of Cost',
  BILL_OF_PARTICULARS = 'Bill of Particulars',
  BOND = 'Bond',
  CERTIFICATE = 'Certificate',
  COMPLAINT = 'Complaint',
  CONFIDENTIAL = 'Confidential',
  COURT_DOCUMENT = 'Court Document',
  COVER_SHEET = 'Cover Sheet',
  DECLARATION_DOCUMENT = 'Declaration Document',
  DEFAULT = 'Default',
  DISCOVERY = 'Discovery',
  DISMISSAL = 'Dismissal',
  DISPOSITION = 'Disposition',
  DISPOSSESSORY_PROCEEDING = 'Dispossessory Proceeding',
  DOCKET_REPORT = 'Docket Report',
  DOC_SUBMISSION = 'Doc Submission',
  EFILING_RECEIPT = 'E-Filing Receipt',
  EVICTION = 'Eviction',
  EXECUTION = 'Execution',
  EXHIBITS = 'Exhibits',
  GARNISHMENT = 'Garnishment',
  GROUNDS_OF_DEFENSE = 'Grounds of Defense',
  INFORMATION = 'Information',
  INTEREST = 'Interest',
  INTERROGATORIES = 'Interrogatories',
  JUDGEMENT = 'Judgement',
  LATE_NOTICE = 'Late Notice',
  LEASE_AGREEMENT = 'Lease Agreement',
  LEASE_APPLICATION = 'Lease Application',
  LEDGER = 'Ledger',
  LETTER = 'Letter',
  LIEN = 'Lien',
  MEMORANDUM = 'Memorandum',
  MISCELLANEOUS = 'Miscellaneous',
  MOTION = 'Motion',
  NOTICE = 'Notice',
  OATH = 'Oath',
  ORDER = 'Order',
  OTHER = 'Other',
  PETITION = 'Petition',
  PRAECIPE = 'Praecipe',
  PROOF_OF_SERVICE = 'Proof of Service',
  REPLY = 'Reply',
  REQUEST_DOCUMENT = 'Request Document',
  RETURN_OF_SERVICE = 'Return of Service',
  SATISFACTION = 'Satisfaction',
  SCRA_DOCUMENT = 'Scra Document',
  SERVICE = 'Service',
  STAMPED_COURT_DOCUMENT = 'Stamped Court Document',
  STATEMENT = 'Statement',
  STIPULATION = 'Stipulation',
  SUBSTITUTION = 'Substitution',
  SUMMARY_EJECTMENT = 'Summary Ejectment',
  SUMMONS = 'Summons',
  SUPPORTING_DOCUMENT = 'Supporting Document',
  VERIFICATION = 'Verification',
  WARRANT = 'Warrant',
  WRIT = 'Writ'
}

/**
 * Types the SERVICE assigns on its own, which a person should never pick by hand.
 *
 * Both are produced by the e-filing round trip (see `ProvanaEFilingAttachmentSaver.resolveAttachmentType`):
 * the receipt for a submission, and the stamped copy the court returns. They exist in this enum so a stored
 * value still maps and DISPLAYS correctly — before they were added, an attachment carrying one of them had
 * no matching client value at all — but offering them in a picker would invite mislabeling.
 *
 * 'Late Notice' is deliberately NOT here: it is an ordinary document someone may legitimately upload.
 */
export const SYSTEM_ASSIGNED_ATTACHMENT_TYPES: ReadonlySet<AttachmentType> = new Set([
  AttachmentType.EFILING_RECEIPT,
  AttachmentType.STAMPED_COURT_DOCUMENT
]);

/** The types offered for manual selection, alphabetical. Use this for any picker, not `Object.values`. */
export const SELECTABLE_ATTACHMENT_TYPES: readonly AttachmentType[] =
  (Object.values(AttachmentType) as AttachmentType[])
    .filter(type => !SYSTEM_ASSIGNED_ATTACHMENT_TYPES.has(type))
    .sort((a, b) => a.localeCompare(b));

/**
 * The same selectable set, keyed by enum KEY, for the pickers that iterate with `| keyvalue` and bind
 * `docType.key` (they store the key, not the label — do not hand those an array of values).
 */
export const SELECTABLE_ATTACHMENT_TYPE_MAP: Readonly<Record<string, AttachmentType>> = Object.fromEntries(
  Object.entries(AttachmentType).filter(
    ([, value]) => !SYSTEM_ASSIGNED_ATTACHMENT_TYPES.has(value)
  )
);
